import { useTranslator } from '@picsart/rc/services/localization';

import Spinner from '@/components/Spinner';
import useUploadMessage from '@/hooks/useUploadMessage';

import useStyles from './styles';

import type { UploadingOverlayProps } from './types';

/**
 * Scrim over an input tile whose file is still travelling to the CDN: spinner
 * plus copy that escalates with elapsed time, so a slow upload can't be
 * mistaken for a stalled one.
 *
 * Its own component purely so that mounting it *is* the message clock's zero
 * (`useUploadMessage` takes no clock). Inlined in `FilePreview` it would mount
 * with the tile and be well past the last mark by the time an upload actually
 * started — a post-login pending upload would open straight on "Slow
 * connection".
 */
const UploadingOverlay = ({ isVideo }: UploadingOverlayProps) => {
  const classes = useStyles();
  const translate = useTranslator();
  const message = useUploadMessage(isVideo ? 'video' : 'photo');

  return (
    <div className={classes.loadingOverlay} data-testid="uploading-overlay">
      <Spinner size="small" className={classes.loadingSpinner} />
      <span className={classes.loadingMessage}>{translate(message)}</span>
    </div>
  );
};

export default UploadingOverlay;
